import { datadogLogs } from '@datadog/browser-logs';
export var datadogLogger = (function () {
    var _loggerConfig;
    var _logger;
    var getLogger = function () {
        if (_logger)
            return _logger;
        else if (_loggerConfig) {
            _logger = datadogLogs.createLogger(_loggerConfig.service + "-logger", {
                context: {
                    service: _loggerConfig.service,
                    env: _loggerConfig.env,
                },
            });
            return _logger;
        }
        else {
            // tslint:disable-next-line:no-console
            console.log('loggerConfig not initiated');
        }
    };
    return {
        init: function (config) {
            _loggerConfig = config;
            datadogLogs.init(config);
        },
        logError: function (errorMessage, error) {
            var logger = getLogger();
            if (logger) {
                var originalError = void 0;
                try {
                    originalError = JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error)));
                }
                catch (e) {
                    originalError = error.toString();
                }
                logger.error(errorMessage, { originalError: originalError });
            }
        },
        logWarn: function (warnMessage) {
            var logger = getLogger();
            if (logger) {
                logger.warn(warnMessage);
            }
        },
        logInfo: function (infoMessage) {
            var logger = getLogger();
            if (logger) {
                logger.info(infoMessage);
            }
        },
    };
})();
